import { Component, OnInit, OnDestroy, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { timer } from 'rxjs';
import { NotificationInterface } from '@core/store/models/notifications.interface';

import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'core-notifications-helpers-event-file-annotations-update-failed',
    templateUrl: './file-annotations-update-failed.component.html',
    styleUrls: ['./file-annotations-update-failed.component.scss']
})
export class CoreNotificationsHelpersEventFileAnnotationsUpdateFailedComponent implements OnInit, OnChanges {

    // EVENT_VERSION_STATUS_UPDATED_FAILED
    @Input() notification: NotificationInterface;

    constructor(private notsSrv: NotificationsService) {
    }

    ngOnInit(){
        // console.log(" notification annotations update failed item ",this.notification)

        // Automatically close the popup after 5 seconds
        // setTimeout(() => this.dismiss(), 5000);
        timer(5000).subscribe(() => this.dismiss());
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes.notification){
        // console.log(" notification was updated ",this.notification)

      }
    }

    dismiss():void {
        this.notsSrv.dismissNotification(this.notification.id);
    }

    refreshPage() {
      this.dismiss();
      window.location.reload();
    }

}
